import { Link } from "react-router-dom";
import type { FilmTitle } from "@/utils/catalog";
import { formatViews } from "@/utils/catalog";
import Stars from "@/components/base/Rating";

interface FilmCardProps {
  item: FilmTitle;
  index?: number;
}

export default function FilmCard({ item, index = 0 }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer"
      style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }}
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} ${item.origTitle} 海报`}
          title={`${item.title} - ${item.genres.join("、")} - CC视频`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/0 to-transparent opacity-70 group-hover:opacity-95 transition-opacity duration-300" />

        <div className="absolute top-2 left-2 flex flex-col gap-1 items-start">
          {item.tags.slice(0, 1).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-500 text-primary-950"
            >
              {tag}
            </span>
          ))}
        </div>

        <span className="absolute top-2 right-2 px-1.5 py-0.5 rounded text-[10px] font-label font-semibold bg-primary-950/70 text-background-50 backdrop-blur-sm">
          {item.kind === "movie" ? "电影" : "剧集"}
        </span>

        <div className="absolute bottom-0 left-0 right-0 p-2.5 md:p-3">
          <div className="flex items-center justify-between gap-2">
            <Stars rating={item.rating} size="sm" />
            <span className="text-[10px] text-background-300 font-label tabular-nums">
              {item.year}
            </span>
          </div>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-11 h-11 rounded-full bg-background-50/90 flex items-center justify-center text-primary-950 text-xl">
            <i className="ri-play-fill" />
          </span>
        </div>
      </div>

      <div className="pt-2.5">
        <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-accent-600 transition-colors">
          {item.title}
        </h3>
        <div className="mt-1 flex items-center gap-1.5 text-xs text-foreground-500 min-w-0">
          <span className="truncate">{item.genres.slice(0, 2).join(" · ")}</span>
          <span className="w-1 h-1 rounded-full bg-background-300 shrink-0" />
          <span className="shrink-0">{item.region}</span>
        </div>
        <p className="mt-1 text-[11px] text-foreground-400 font-label tabular-nums">
          {formatViews(item.views)}
        </p>
      </div>
    </Link>
  );
}